import actionTypes from "../common/actionTypes";
import { DATABASE_STATUTES } from "../common/constants";

const integrationReducer = (state, action) => {
  switch (action.type) {
    case actionTypes.FETCH_INTEGRATIONS_DATA:
      return {
        ...state,
        error: null,
        status: DATABASE_STATUTES.LOADING,
        data: [],
      };

    case actionTypes.FETCH_INTEGRATIONS_DATA_SUCCESS:
      return {
        ...state,
        data: action.payload,
        status: DATABASE_STATUTES.LOADED,
      };

    case actionTypes.FETCH_INTEGRATIONS_DATA_FAILURE:
      return {
        ...state,
        error: action.payload,
        status: DATABASE_STATUTES.LOADED,
      };
    default:
      return state;
  }
};

export default integrationReducer;
